/*
 * Copyright (c) 2020. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import ServerRequest from "./server-request";
import urlJoin from "proper-url-join";

const getOpeningHours = async () => {
  let request = new ServerRequest(
    urlJoin(process.env.VUE_APP_BACKEND_URL, "opening-hours")
  );
  return await request.getData();
};

const OpeningHoursService = {
  getOpeningHours
};

export default OpeningHoursService;
export { getOpeningHours };
